<template>
  <div class="mf-materials-entries">
    <div class="row">
      <TransitionGroup name="material-grid">
        <div
          v-for="(material, index) in items"
          :key="index"
          :class="['mf-materials-entry', 'col-6 col-sm-4 col-lg-3 col-xxl-20pct']"
        >
          <div class="mf-materials-entry-wrapper">
            <div class="mf-materials-entry-image">
              <img
                v-if="material.image"
                :src="material.image"
                :alt="material.name"
              >
            </div>
            <div class="mf-materials-entry-contents">
              <div class="mf-materials-entry-contents-info">
                <span class="id">{{ uppercase(material.id) }}</span>
                <span class="categories">{{ material.category }} | {{ material.subcategory }}</span>
              </div>
              <span class="mf-materials-entry-contents-title">{{ material.name }}</span>
              <div class="mf-materials-entry-contents-tags">
                <div
                  v-if="material.special"
                  :class="['mf-materials-entry-contents-tags-entry', slugify(material.special)]"
                >
                  <span>{{ material.special }}</span>
                </div>
                <div
                  v-if="material.stretchable"
                  class="mf-materials-entry-contents-tags-entry stretchable"
                >
                  <span>Dehnbar</span>
                </div>
              </div>
              <div
                v-if="hasActions(material)"
                class="mf-materials-entry-contents-actions"
              >
                <a
                  v-if="material.datasheet.length > 0"
                  :href="material.datasheet"
                  class="mf-materials-entry-contents-actions-button datasheet"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Datenblatt öffnen"
                >
                  <span class="label">Datenblatt</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </TransitionGroup>
      <Transition name="fade">
        <div
          v-if="items.length === 0"
          class="mf-materials-entry mf-materials-entry-empty col-12"
        >
          Keine Einträge gefunden!
        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import slugify from '@sindresorhus/slugify';

// define props
defineProps<{
  items: IMaterialEntry[];
}>();

const uppercase = (value: string) => value.toUpperCase();

const hasActions = (material: IMaterialEntry) => {
  return material.datasheet && material.datasheet.length > 0;
};
</script>
